import { Color3, Engine, MeshBuilder, StandardMaterial } from "babylonjs";
import CreatorElement from "./creator.element";
import { IAssetTexture, loadTexture } from "../loader/loader";

// An image panel: a textured unit plane whose world size comes from the anchor
// scale ([w, h, 1] → the image aspect), facing the viewer.
export default class CreatorImageElement extends CreatorElement {
  public async build(): Promise<void> {
    const asset: IAssetTexture = { type: "texture", path: this.file.path, id: this.sceneID };
    await loadTexture(asset, this.scene);
    const tex = asset.texture;
    if (!tex) return;

    tex.hasAlpha = true;
    tex.vScale = -1; // flip V so the texture isn't upside-down.
    tex.uScale = -1; // flip U so text reads correctly (not mirrored).

    const plane = MeshBuilder.CreatePlane(`${this.sceneID}_image`, { size: 1 }, this.scene);
    plane.parent = this.anchor;

    const material = new StandardMaterial(`${this.sceneID}_mat`, this.scene);
    material.diffuseTexture = tex;
    material.emissiveTexture = tex;
    material.emissiveColor = new Color3(1, 1, 1);
    material.disableLighting = true;
    material.backFaceCulling = false;
    material.useAlphaFromDiffuseTexture = true;
    material.alphaMode = Engine.ALPHA_COMBINE;
    plane.material = material;

    this.applyTransform(); // anchor carries position + rotation + scale.
  }
}
